import React, { useEffect, useState } from "react";
import "./ChangePassword.css";
import { getChangePasswords } from "../../../config/LiveApi";
import Pagination from "../pagination";
import { toast } from "react-toastify";
import DataTable from "../../../components/common/DataTable/DataTable";
import Spinner from "../../Spin/Spinner";

const ChangePasswordPage = () => {
  const [statusData, setStatusData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchChangePasswordData = async (currentPage, searchTerm) => {
    try {
      setLoading(true);
      const response = await getChangePasswords(currentPage, searchTerm);
      setStatusData(response);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("Unable to fetch status.");
    }
  };
  useEffect(() => {
    if (searchTerm !== "") {
      const delayDebounce = setTimeout(() => {
        fetchChangePasswordData(1, searchTerm);
      }, 2000);

      return () => clearTimeout(delayDebounce);
    }
  }, [searchTerm]);

  useEffect(() => {
    if (searchTerm === "") {
      fetchChangePasswordData(currentPage, "");
    }
  }, [currentPage, searchTerm]);

  const columns = [
    {
      key: "name",
      header: "Name",
      wrapCell: true,
    },
    {
      key: "email",
      header: "Email",
      wrapCell: true,
    },
    {
      key: "updatedAt",
      header: "Updated At",
      wrapCell: true,
    },
  ];

  const formattedData =
    statusData?.map((item) => ({
      name: item?.alias || item?.name || "-",
      email: item?.email || "-",
      updatedAt: item?.updatedAt
        ? new Date(item.updatedAt).toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          })
        : "-",
    })) || [];

  return (
    <div className="change-password-table-container">
      <div className="change-password-heading">
        <h2 className="change-password-table-title">Change Password</h2>
        <input
          className="password-input-field-container"
          type="text"
          placeholder="Email"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <div>
        {loading ? (
          <Spinner />
        ) : (
          <DataTable
            columns={columns}
            data={formattedData}
            emptyMessage="No data found."
          />
        )}
      </div>
      <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} />
    </div>
  );
};

export default ChangePasswordPage;
